import { IModelsClient } from "@itwin/imodels-client-management";
import { useBuddiContext } from '../../context/buddiContext/buddiContext';
import { useMemo } from "react";

export const useIModelClient = () => {
  const { buddiUrls } = useBuddiContext();
  const iModelsClient = useMemo(() => {
    return new IModelsClient({
      api: { baseUrl: buddiUrls.iModelsAPIsUrl },
      headers: { "Cache-Control": "no-cache" },
    });
  }, []);

  return { iModelsClient };
};

export const getAuthorizationForIModelClient = async (accessToken: string, tokenType: string) => {
  return { scheme: tokenType, token: accessToken };
};